export default __webpack_public_path__ + "static/media/Rooftop-Terrace.7ef40d75.webp";